import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@config/queryClient";
import feedbackService from "@services/feedback.service";
import { CREATE_FEEDBACK_MUTATION_KEY, THREAD_AI_CONTEXT_QUERY_KEY } from "@config/query";
import type {
  IThreadAIContextResponse,
  ISubmitFeedbackPayload,
} from "@interfaces/thread.interface";

export function useCreateFeedback(threadId: string) {
  return useMutation({
    mutationKey: [CREATE_FEEDBACK_MUTATION_KEY],
    mutationFn: (payload: ISubmitFeedbackPayload) =>
      feedbackService.createThreadContextFeedback(payload),
    onSuccess: (_data, variables) => {
      queryClient.setQueryData<IThreadAIContextResponse>(
        [THREAD_AI_CONTEXT_QUERY_KEY, threadId],
        (old) => {
          if (!old) return old;
          return {
            ...old,
            feedback: {
              id: "",
              rating: variables.rating,
              reasons: variables.reasons ?? [],
              comment: variables.comment ?? "",
              created: new Date().toISOString(),
            },
          };
        }
      );
    },
  });
}
